export class SmartTagRemovalOperations {
    #deps;
    constructor(deps) {
        this.#deps = deps;
    }
    removeTag = (tag) => {
        this.#deps.logger.log('remove:', tag);
        return new Promise((resolve, reject) => {
            const validation = this.#validateTagForRemoval(tag);
            if (!validation.isValid) {
                reject({ msg: validation.error });
                return;
            }
            this.#executeTagRemoval(tag, resolve, reject);
        });
    };
    #validateTagForRemoval(tag) {
        if (this.#deps.utilities?.Type?.isUndefined?.(tag)) {
            return {
                isValid: false,
                error: 'Failure: Tag instance is undefined. Request to remove rejected.'
            };
        }
        if (!this.#isValidTagStructure(tag)) {
            return {
                isValid: false,
                error: 'Failure: Tag API structure is invalid. Cannot reset tag.'
            };
        }
        return { isValid: true };
    }
    #isValidTagStructure(tag) {
        try {
            return !this.#deps.utilities?.Type?.isUndefined?.(tag?.API) &&
                !this.#deps.utilities?.Type?.isUndefined?.(tag?.API?.TAG) &&
                this.#deps.utilities?.Type?.isFunction?.(tag?.API?.TAG?.reset);
        }
        catch (error) {
            this.#deps.logger.warn('remove:', 'Error validating tag structure:', error);
            return false;
        }
    }
    #executeTagRemoval(tag, resolve, reject) {
        try {
            tag.API.TAG.reset().then((data) => {
                this.#deps.logger.log('remove:', 'Tag.reset():', data, 'Done!');
                this.#cleanupRemovedTag(tag, resolve, reject);
            }).catch((resetError) => {
                this.#deps.logger.warn('remove:', 'Tag.reset() failed:', resetError);
                reject({ msg: 'Failure: Tag reset failed.', error: resetError });
            });
        }
        catch (synchronousError) {
            this.#deps.logger.warn('remove:', 'Synchronous error during tag reset:', synchronousError);
            reject({ msg: 'Failure: Synchronous error during tag reset.', error: synchronousError });
        }
    }
    #cleanupRemovedTag(tag, resolve, reject) {
        try {
            if (!this.#deps.utilities?.Array?.indexOf) {
                this.#deps.logger.warn('remove:', 'Array utilities not available for cleanup');
                this.#finalizeRemoval(resolve, reject);
                return;
            }
            const list = this.#deps.getList();
            if (!list) {
                this.#deps.logger.warn('remove:', 'List not available for cleanup');
                this.#finalizeRemoval(resolve, reject);
                return;
            }
            const indexToDelete = this.#deps.utilities.Array.indexOf('uuid', tag.uuid, list);
            if (indexToDelete !== null && indexToDelete !== undefined) {
                this.#deps.removeFromList(tag.uuid);
                this.#deps.removeFromRegistry(tag.uuid);
            }
            this.#finalizeRemoval(resolve, reject);
        }
        catch (cleanupError) {
            this.#deps.logger.warn('remove:', 'Error during cleanup operations:', cleanupError);
            reject({ msg: 'Failure: Error during tag cleanup operations.', error: cleanupError });
        }
    }
    #finalizeRemoval(resolve, reject) {
        if (this.#deps.utilities?.Delay?.delay) {
            this.#deps.utilities.Delay.delay().then(() => {
                this.#deps.logger.log('remove:', 'inform the app!');
                resolve({ msg: 'Success: tag was removed.' });
            }).catch((delayError) => {
                this.#deps.logger.warn('remove:', 'Delay.delay() failed:', delayError);
                resolve({ msg: 'Success: tag was removed (delay warning).' });
            });
        }
        else {
            this.#deps.logger.log('remove:', 'inform the app!');
            resolve({ msg: 'Success: tag was removed.' });
        }
    }
}
